<template>
    <div class="showTile" @click="viewShowDetails">
        <span>
            <h3 class="truncate-text">
                {{ show.venue }}
            </h3>
            pending: {{ show.pendingPhotos }}
            approved: {{ show.approvedPhotos }}
        </span>

        <span>
            <!-- note: details button does not need a handler because parent div consumes the click
                     button is really just to indicate user can click on the tile to edit the show -->
            <v-btn size="x-small">Details</v-btn>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Show',
    props: {
        show: Object
    },
    emits: [
        'view-show-details' // Declare the event this component emits
    ],
    computed: {
        formattedDate() {
            return this.show.showDateShort();
        }
    },
    methods: {
        viewShowDetails() {
            this.$emit('view-show-details', this.show);
        }
    }
}
</script>

<style scoped>
.showTile {
    border: 1px solid black;
    border-radius: 10px;
    background-color: white;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 10px;
    cursor: pointer;
    /* Make the container a flexbox */
    display: flex;
    /* Push children to opposite ends */
    justify-content: space-between;
    /* Align items to the top */
    align-items: flex-start;
}
</style>
